import React, { Component } from 'react';
//import { Link } from 'react-router-dom';
//import './App.css';
//import firebase from './../Firestore'

class Imagen extends Component {
  // constructor(props) {
  //   super(props);
  //
  // }



  render() {

    if(this.props.imagen === "" || typeof(this.props.imagen) === "undefined") return ""

    // let pathServidor = "../../img/productos/"
    // let pathStorage = "gs://app-pizzerias.appspot.com/productos/"


    return (


        <img alt={this.props.nombre} className="img-fluid float-left rounded w-25 border mr-1" src={this.props.imagen} />


    );
  }
}

export default Imagen;
